module.exports = __webpack_public_path__ + "fonts/0f8d5b8.woff2";